import { render, staticRenderFns } from "./work_detail.vue?vue&type=template&id=76741f31&scoped=true"
import script from "./work_detail.vue?vue&type=script&lang=js"
export * from "./work_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76741f31",
  null
  
)

export default component.exports